export default __webpack_public_path__ + "static/media/painting28.1e7e5e54.jpeg";